(function () {
  function init() {
    var sections = document.querySelectorAll('.Collection-bottom');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var content = section.querySelector('.Collection-bottom__content');
      var toggle = section.querySelector('.Collection-bottom__toggle');
      var textEl = section.querySelector('.Collection-bottom__text');
      if (!content || !toggle || !textEl) return;

      if (toggle.dataset.initialized) return;
      toggle.dataset.initialized = 'true';

      // Move media blocks to correct positions between headings
      var mediaBlocks = textEl.querySelectorAll('[data-insert-after-heading]');
      if (mediaBlocks.length > 0) {
        var headings = Array.from(textEl.querySelectorAll('h3, h4'));

        // Sort blocks by position (highest first so earlier inserts don't shift later ones)
        var sortedBlocks = Array.from(mediaBlocks).sort(function (a, b) {
          return parseInt(b.getAttribute('data-insert-after-heading')) - parseInt(a.getAttribute('data-insert-after-heading'));
        });

        sortedBlocks.forEach(function (block) {
          var pos = parseInt(block.getAttribute('data-insert-after-heading'), 10);
          block.style.display = '';

          if (pos > 0 && pos < headings.length) {
            // Insert right before the NEXT heading
            headings[pos].before(block);
          } else if (pos > 0 && pos === headings.length) {
            // After last heading section — find last element and put after it
            var lastChild = textEl.lastElementChild;
            if (lastChild && lastChild !== block) {
              lastChild.after(block);
            }
          }
          // pos 0 stays at end (already there from HTML order)
        });
      }

      // Autoplay videos when they become visible
      var videos = textEl.querySelectorAll('video');
      if (videos.length > 0 && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.play().catch(function () {});
            }
          });
        }, { threshold: 0.3 });
        videos.forEach(function (v) { observer.observe(v); });
      }

      // Start collapsed
      content.setAttribute('data-collapsed', 'true');
      content.style.maxHeight = '150px';

      toggle.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var isCollapsed = content.getAttribute('data-collapsed') === 'true';
        if (isCollapsed) {
          content.setAttribute('data-collapsed', 'false');
          content.style.maxHeight = textEl.scrollHeight + 500 + 'px';
        } else {
          content.setAttribute('data-collapsed', 'true');
          content.style.maxHeight = '150px';
        }
        return false;
      };
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
